module.exports = __webpack_public_path__ + "static/media/iPhonex.eddfe5ab.png";